import _ from 'lodash';

export default {
  SET_ERROR(state, errorMsg) {
    state.errors.message = errorMsg;
  },

  // Steps
  SET_CURRENT_STEP(state, step) {
    state.steps.current = step;
  },
  SET_NEXT_STEP(state, step) {
    state.steps.next = step;
  },
  SET_PREVIOUS_STEP(state, step) {
    state.steps.previous = step;
  },
  SET_NEXT_TO_REVIEW(state, value) {
    state.steps.nextReview = value;
  },

  // Include the isResident question
  SET_IS_RESIDENT_REQUIREMENT(state, value) {
    state.steps.isResidentRequired = value;
  },

  // Update The Steps to include all the questions to ask
  SET_STEPS_MAP_WITH_QUESTIONS(state, questions) {
    // Split the array into sections
    const numSteps = state.steps.pathing.length;
    const questionsIndex = state.steps.pathing.indexOf('/questions');
    const firstSteps = state.steps.pathing.slice(0, questionsIndex);
    const lastSteps = state.steps.pathing.slice(questionsIndex + 1, numSteps);

    // Find index of first owner-occupied question.
    // If we need to verify if the unit is a resident, we should do so
    // before the first OO question (to account for multiple OO questions).
    const occupiedIndex = questions.findIndex(q => q.type === 'owner-occupied');

    // Figure out the number of questions that will be asked
    const questionsSteps = questions.map((question, index) => {
      return `/questions/${index}`;
    });

    // If we need to verify if a unit is a resident, insert it into our path
    if (state.steps.isResidentRequired) {
      questionsSteps.splice(occupiedIndex, 0, '/isresident');
    }
    // Update the Steps Map
    let pathing = [...firstSteps, ...questionsSteps, ...lastSteps];

    // Set the pathing
    state.steps.pathing = pathing;

    // set index for first occurence of category path
    state.steps.stepMap.forEach(function(step) {
      step.startIndex = pathing.indexOf(step.path);
    });
  },

  SET_STEPS_MAP_WITH_NO_QUESTIONS(state) {
    // set index for first occurence of category path
    state.steps.stepMap.forEach(function(step) {
      step.startIndex = state.steps.pathing.indexOf(step.path);
    });
  },

  SET_STEPS_ASK_FIRST_PROXYHOLDER(state, path) {
    const currSteps = [...state.steps.pathing];
    let movedSteps = [];

    let firstQuestionIndex = state.steps.pathing.indexOf('/questions/0');

    if (firstQuestionIndex !== -1) {
      movedSteps = _.remove(currSteps, k => k !== path);
      movedSteps.splice(firstQuestionIndex, 0, path);

      // Only happens if questions exist
      state.steps.pathing = movedSteps;
    }
  },

  // If this proxy doesn't require a specific path (Eg. proxy), then remove it
  // from pathing
  SET_STEPS_SKIP_STEP(state, path) {
    const currSteps = [...state.steps.pathing];
    const stepsWithoutPath = _.remove(currSteps, k => k !== path);
    state.steps.pathing = stepsWithoutPath;

    // reset startIndex
    state.steps.stepMap.forEach(function(step) {
      step.startIndex = state.steps.pathing.indexOf(step.path);
    });
  },

  // Set the Tracking code
  SET_TRACKING_CODE(state, trackingCode) {
    state.trackingCode = trackingCode;
  },

  SET_SHORT_CODE(state, shortCode) {
    state.shortCode = shortCode;
  },

  // Set the user's verified token
  SET_TOKEN(state, token) {
    state.token = token;
  },

  SET_APP_DISPLAY_OPTIONS(state, appDisplayOptions) {
    state.appDisplayOptions = appDisplayOptions;
  },

  SET_MEETING_OPTIONS(state, meetingOptions) {
    state.meetingOptions = meetingOptions;
  },

  SET_SHOW_RSVP_MODAL(state, showModal = false) {
    state.showRsvpModal = showModal;
  },

  SET_SHOW_REVOKE_MODAL(state, showModal = false) {
    state.showRevokeModal = showModal;
  },

  TOGGLE_RSVP_MODAL(state) {
    state.showRsvpModal = !state.showRsvpModal;
  },
  SET_BLOCK_UNVERIFIED_VOTING(state, value) {
    state.blockUnverifiedVoting = value;
  },
  SET_CUSTOM_SIGNATURE(state, value) {
    const customSignature = value
      ? `<img src="${value}" alt="Signature" />`
      : null;
    state.customSignature = customSignature;
  },

  SET_PUSHER(state, value) {
    state.pusher = value;
  },

  CLEAR_PUSHER(state) {
    state.pusher.disconnect();
    state.pusher = null;
  },

  SET_PREVIEW_MODE(state, value) {
    state.previewMode = value;
  }
};
